<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Container, Text, Button, Alert } from '@Shelly/shelly-design-system';
	import type { Device } from 'src/types/Device';
	import TemplatesModal from 'src/components/Templates/TemplatesModal.svelte';
	import SaveTemplateModal from 'src/components/Templates/SaveTemplateModal.svelte';
	import { getDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	import { isDeviceTemplatesSupported } from 'src/helpers/settings/settings_config_helpers';
	import { capFirstChar } from 'src/helpers/utilities';

	export let device: Device;

	$: statusStore = getDeviceStatus(device.id);
	$: isOnline = $statusStore?.online;

	let showTemplatesModal = false;
	let showSaveTemplateModal = false;

	const handleApplySettings = () => {
		showTemplatesModal = true;
	};

	const handleSaveConfiguration = () => {
		showSaveTemplateModal = true;
	};
</script>

{#if isDeviceTemplatesSupported(device) && isOnline}
	<Alert
		isHeadingBold={true}
		heading={$format('text_template_modal_title_apply', {
			default: 'Apply Settings Configuration',
		})}
		message={$format('text_template_modal_message_apply', {
			default:
				'You can apply settings either from existing device or pre-saved settings template.',
		})}
		cta={{
			title: capFirstChar(
				$format('button_apply', {
					default: 'Apply',
				}),
			),
		}}
		on:cta_click={handleApplySettings}
	/>

	<Alert
		class="mt-m"
		isHeadingBold={true}
		heading={$format('text_template_modal_title_manage', {
			default: 'Save device configuration',
		})}
		message={$format('text_template_modal_message_save', {
			default:
				'You can save current device settings as a template to apply them to other devices later.',
		})}
		cta={{
			title: capFirstChar(
				$format('button_save', {
					default: 'Save',
				}),
			),
		}}
		on:cta_click={handleSaveConfiguration}
	/>
{:else if isDeviceTemplatesSupported(device) && !isOnline}
	<Alert
		type="warning"
		heading={$format('device_offline', {
			default: 'Device Offline',
		})}
		message={$format('device_offline_message', {
			default:
				'This device is currently offline. You need to connect the device to use the Apply Settings Configuration feature.',
		})}
	/>
{:else}
	<Alert
		type="info"
		heading={$format('feature_not_supported', {
			default: 'Feature Not Supported',
		})}
		message={$format('apply_settings_not_supported_message', {
			default: 'This device does not support the Apply Settings Configuration feature.',
		})}
	/>
{/if}

{#if showTemplatesModal}
	<TemplatesModal bind:showModal={showTemplatesModal} {device} mode="select" />
{/if}

{#if showSaveTemplateModal}
	<SaveTemplateModal bind:showModal={showSaveTemplateModal} {device} />
{/if}
